import { Injectable } from '@angular/core';

import { pipe, Subject, throwError, UnaryFunction } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthorisationStrategy, HttpApiErrorHandlerService } from '@recruitee/http';

@Injectable()
export class TellentAdminHttpApiErrorHandlerService implements HttpApiErrorHandlerService {
  public internalServerError$ = new Subject<void>();

  constructor(private authorisationStrategy: AuthorisationStrategy) {}

  public handleError(url: string, preventDefault?: boolean): UnaryFunction<any, any> {
    return pipe(
      catchError(error => {
        if (preventDefault) {
          return throwError(error);
        }

        switch (error.status) {
          case 401:
            this.authorisationStrategy.onUnauthorized(error);
            break;
          case 403:
            this.authorisationStrategy.onForbidden(error);
            break;
          case 500:
            this.internalServerError$.next(error);
            break;
          default:
            break;
        }
        return throwError(error);
      }),
    );
  }
}
